import { IMeetingSession } from '../interfaces/event';

export const instanceOfMeeting = (object: any): object is IMeetingSession => {
  if (!object || typeof object === 'string' || typeof object === 'number') {
    return false;
  }

  return 'category' in object;
};
